import styled, { keyframes } from "styled-components";
import { Box } from "@mui/material";

const pulse = keyframes`
	0%, 100% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.06);
	}
`;

export const SalesBannerWrapper = styled(Box)`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1300;
	width: 100%;
	background: linear-gradient(90deg, #ff3d68, #ff7a3d, #ffb23d);
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
	color: #fff;

	.progress_track {
		width: 100%;
		height: 3px;
		background: rgba(255, 255, 255, 0.25);
	}

	.progress_fill {
		height: 100%;
		background: #fff;
		transition: width 1s linear;
	}

	.content {
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: center;
		gap: 10px 20px;
		padding: 8px 16px;
		text-align: center;
	}

	.copy {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: center;
		gap: 8px;
	}

	.discount_label {
		display: inline-flex;
		align-items: center;
		font-weight: 800;
		font-size: 15px;
		letter-spacing: 0.5px;
		background: rgba(0, 0, 0, 0.2);
		border-radius: 20px;
		padding: 3px 12px;
		animation: ${pulse} 1.8s ease-in-out infinite;
	}

	.sub_copy {
		font-size: 16px;
		font-weight: 600;
		opacity: 0.95;
	}

	.timer {
		display: flex;
		align-items: center;
		gap: 5px;
	}

	.timer_segment {
		display: flex;
		flex-direction: row;
		align-items: baseline;
		gap: 3px;
		background: rgba(0, 0, 0, 0.25);
		border-radius: 6px;
		padding: 3px 6px;
		min-width: 34px;
		justify-content: center;

		.value {
			font-weight: 700;
			font-size: 14px;
			font-variant-numeric: tabular-nums;
		}

		.label {
			font-size: 11px;
			text-transform: uppercase;
			opacity: 0.85;
		}
	}

	.cta {
		display: inline-flex;
		align-items: center;
		background: #fff;
		color: #d81b46;
		font-weight: 700;
		font-size: 13px;
		padding: 6px 16px;
		border: 0;
		border-radius: 20px;
		cursor: pointer;
		font-family: inherit;
		white-space: nowrap;
		transition: transform 0.2s ease;

		&:hover {
			transform: scale(1.05);
		}
	}

	${props => props.theme.breakpoints.down("sm")} {
		.content {
			padding: 8px 10px;
			gap: 6px 12px;
		}

		.discount_label {
			font-size: 13px;
		}

		.sub_copy {
			display: none;
		}
	}
`;
